import { AppliedDiscountsItem } from '@airship-platform/airship-proposal';
import { FlexBox } from '@airship-platform/jam-web/components';

interface ProposalTemplateDiscountsListProps {
  discounts: {
    proposalTemplateOptionModifierId: string;
    displayName: string;
  }[];
}

const ProposalTemplateDiscountsList: React.FC<
  ProposalTemplateDiscountsListProps
> = ({ discounts }) => {
  if (!discounts.length) {
    return null;
  }

  return (
    <FlexBox gap={3}>
      {discounts.map((optionModifier) => (
        <AppliedDiscountsItem
          key={optionModifier.proposalTemplateOptionModifierId}
          displayName={optionModifier.displayName || 'Discount'}
        />
      ))}
    </FlexBox>
  );
};

export default ProposalTemplateDiscountsList;
